<div class="card-container">
    <div class="column card-light">
        <div class="card-light-container">
          <cel-icon
              class="realize-logo"
              data-aria-label="Savvas Realize Logo"
              data-src="./assets/logo/logo_realize_dark.svg"
              [dialogCloseIconRole]="logoImageRole">
          </cel-icon>
            <div class="demo-container">
              <div class="text-content">
                <h1 class="setup-account-title">{{ setupDemoAccountTitle }}</h1>
                <p class="setup-instructions">
                  {{ setupDemoAccountInstructions }}
                </p>
                <div class="modal-link-container">
                  <cel-icon
                    class="checkmark-icon"
                    data-name="checkmark-circle"
                    *ngIf="iconShowed">
                  </cel-icon>
                  <cel-text-link
                    class="modal-link"
                    [label]="demoAccountConditions"
                    (click)="openModal()"
                    [attr.data-aria-label]="demoAccountConditions"
                    aria-haspopup="dialog"
                    #conditionLink>
                  </cel-text-link>
                </div>
                  <div class="error-container" role="alert" aria-live="true" *ngIf="!hasAcceptedTerms && linkClicked">
                    <cel-icon
                      class="error-icon"
                      data-name="alert-circle"
                      data-size="small"
                      data-color="error"
                      aria-label="alert" role="img">
                    </cel-icon>
                    <span class="error-message">Please agree to the conditions</span>
                  </div>
                  <div class="recaptcha-container">
                    <re-captcha
                      #captchaRef="reCaptcha"
                      siteKey="{{ siteKey }}"
                      (resolved)="resolved($event)"
                      (errored)="handleCaptchaError()"
                      size="invisible">
                    </re-captcha>
                    This site is protected by reCAPTCHA and the Google <a href="https://policies.google.com/privacy">Privacy Policy</a> and <a href="https://policies.google.com/terms">Terms of Service</a> apply.
                  </div>
                  <app-consent-modal
                    *ngIf="displayModal"
                    (toggle)="closeModal($event)">
                  </app-consent-modal>
                </div>
            </div>
        </div>
    </div>
    <div class="column card-dark">
        <div class="card-dark-container">
            <form #formRef="ngForm" [formGroup]="demoForm" method="post">
                <div class="form-container">
                  <div class="email-input">
                    <cel-text-field
                      ngDefaultControl
                      formControlName="email"
                      class="email-field"
                      data-field-label="Your email"
                      [attr.data-enable-error]="emailError"
                      [statusConfig]="emailStatusConfig"
                      data-aria-label="Your email"
                      #emailElem
                      (blur)="handleEmailBlur()"
                    ></cel-text-field>
                  </div>
                  <div class="password-input">
                    <cel-text-field
                      ngDefaultControl
                      formControlName="password"
                      class="password-field"
                      data-field-label="Create a password"
                      data-input-type="password"
                      data-toggle-password="true"
                      [attr.data-enable-error]="passwordError"
                      data-enable-custom="true"
                      [statusConfig]="passwordStatusConfig"
                      data-aria-label="Create a password"
                      (blur)="handlePaswordBlur()"
                      #pasword
                    ></cel-text-field>
                  </div>
                  <div class="dropdown-input">
                    <cel-single-select
                      ngDefaultControl
                      formControlName="orgId"
                      data-primary="true"
                      [menuList]="dropdownOrganizations"
                      (celSingleSelect)="selectOrganization($event)"
                      class="dropdown"
                      (blur)="handleOrgBlur()"
                      (click)="handleOrgClick()"
                      data-placeholder="Select organization"
                      data-single-select-aria-label="Select where you'd like to sample products"
                      data-secondary-label="Select where you'd like to sample products"
                      data-none=""
                      [statusConfig]="orgStatusConfig"
                      [attr.data-enable-error]="orgError"
                    ></cel-single-select>
                  </div>
                  <div class="create-demo-account-btn">
                    <cel-button
                      class="submit-btn"
                      [attr.data-disabled]="demoForm.invalid || !hasAcceptedTerms"
                      data-label="{{ createDemoAccountButtonLabel }}"
                      (celButtonOnClick)="captchaRef.execute()"
                    ></cel-button>
                  </div>
                </div>
              </form>
        </div>
    </div>
</div>
